import { useState } from 'react';
import { getAuthenticatedClient } from '../Utils/tokenHelper';
import { useAccount, useMsal } from '@azure/msal-react';
import { enableFrontdoor } from '../Utils/features';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_PRICER_API_BASE_URL_FRONTDOOR : process.env.REACT_APP_PRICER_API_BASE_URL;

export default function useCancelBatchApi() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0]);

    const execute = async (batchId) => {
        setError(undefined);
        setLoading(true);

        try {
            await (await getAuthenticatedClient({
                method: 'POST',
                url: `${BASE_URL}/status/event`,
                body: {
                    batchId,
                    eventType: 'Batch',
                    eventName: 'BatchCancelled',
                    eventDate: new Date().toISOString(),
                    source: 'MRPPortal'
                },
                account,
                msalInstance: instance
            }))
        } catch (e) {
            setError(e);
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        execute
    };
}